// register all modals
import '@/shared/ui/modals';

import NiceModal from '@ebay/nice-modal-react';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';

import { env } from '@/shared/config/env';
import { i18n } from '@/shared/config/i18n';
import { twa } from '@/shared/lib/telegram/twa';

import { store } from '../store';

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  useEffect(() => {
    if (env.ENVIRONMENT === 'production' && twa.isInsideTelegram()) {
      twa.init();
      const bg =
        getComputedStyle(document.documentElement).getPropertyValue('--midnight-blue').trim() ||
        '#0a0e27';
      twa.setBackgroundColor(bg);
      twa.setHeaderColor(bg);
    }
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <TonConnectUIProvider manifestUrl="https://botyara2026bot.shop/tonconnect-manifest.json">
        <Provider store={store}>
          <NiceModal.Provider>{children}</NiceModal.Provider>
        </Provider>
      </TonConnectUIProvider>
    </I18nextProvider>
  );
};
